import { useState, createContext, useContext, useEffect } from 'react';
import { uploadSheet } from '../services/uploadFile';
import { uploadOnos, uploadVnos } from '../enums/endpoints';

const FileUploadContext = createContext<any>('');

export const FileUploadProvider = (props: any) => {
  const [uploadExcelData, setUploadExcelData] = useState<any[]>([]);
  const [uploadView, setUploadView] = useState<string>('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [successWindow, setSuccessWindow] = useState({
    status: false,
    message: '',
    uploadScreen: uploadView,
  });
  const [failedWindow, setFailedWindow] = useState<any>({
    status: false,
    message: '',
    uploadScreen: uploadView,
  });
  const [errorWindow, setErrorWindow] = useState({
    status: false,
    message: '',
  });

  const handleFileUpload = (data: any[]) => {
    setUploadExcelData(data);
  };

  useEffect(() => {
    const endpoint = uploadView === 'uploadOnos' ? uploadOnos : uploadVnos;
    const key = uploadView === 'uploadOnos' ? 'onos' : 'vnos';
    if (Object.keys(uploadExcelData)?.length !== 0) {
      uploadSheet(
        endpoint,
        uploadExcelData,
        key,
        setUploadProgress,
        setUploadView,
        setSuccessWindow,
        setFailedWindow,
        setErrorWindow,
        failedWindow,
        successWindow
      );
    }
  }, [uploadExcelData]);

  useEffect(() => {}, [uploadProgress]);

  return (
    <FileUploadContext.Provider
      value={{
        uploadExcelData,
        handleFileUpload,
        uploadView,
        setUploadView,
        uploadProgress,
        setUploadProgress,
        successWindow,
        setSuccessWindow,
        failedWindow,
        setFailedWindow,
        errorWindow,
        setErrorWindow,
      }}
    >
      {props.children}
    </FileUploadContext.Provider>
  );
};

export const useFileUploadContext = (): any => {
  const context = useContext(FileUploadContext);
  if (!context) {
    throw new Error(
      'useFileUploadContext must be used within a FileUploadProvider'
    );
  }
  return context;
};
